import React, { Component } from 'react'
import classnames from 'classnames'

import Form from '../Form'
import EmailDefaults from './Defaults'
import NewUserEmailTemplate from './NewUserEmailTemplate'
import ImportedUserEmailTemplate from './ImportedUserEmailTemplate'
import SubscriptionTemplate from './SubscriptionTemplate'
import QuickResponseTemplate from './QuickResponseTemplate'
import RecommendedSearchTemplate from './RecommendedSearchTemplate'

export default class EmailSettings extends Component {
  state = {
    validations: null
  }

  registerValidations = validations => this.setState({ validations })
  registerDataHandler = handler => this.dataHandler = handler
  handleData = data => this.dataHandler(data)

  renderTab() {
    const { tab } = this.state

    switch (tab) {
      case 'new_user_template': return NewUserEmailTemplate
      case 'imported_user_template': return ImportedUserEmailTemplate
      case 'recommended_search_template': return RecommendedSearchTemplate
      case 'search_subscription_template': return SubscriptionTemplate
      case 'quick_response_template': return QuickResponseTemplate
      default: return EmailDefaults
    }
  }

  renderTabs() {
    const { tab:current } = this.state

    const getClass = tab => {
      return classnames('tab', {
        active: current ? tab === current : tab === 'default'
      })
    }

    const setTab = tab => () => this.setState({ tab })
    const getTab = (tab, label) => (
      <div className={getClass(tab)} onClick={setTab(tab)}>{label}</div>
    )

    return (
      <div className="tabs">
        <div className="end" />
        {getTab('default', 'Sending')}
        {getTab('new_user_template', 'Lead Sign Up Template')}
        {getTab('imported_user_template', 'Imported Lead Template')}
        {getTab('recommended_search_template', 'Recommended Search Template')}
        {getTab('search_subscription_template', 'Saved Search Templates')}
        {getTab('quick_response_template', 'Quick Responses')}
        <div className="end" />
      </div>
    )
  }

  render() {
    const Tab = this.renderTab()

    return (
      <div className="container padded settings">
        <Form onData={this.handleData} validations={this.state.validations}>
          <div className="panel padded">
            <h2 className="title">Email Settings</h2>
            {this.renderTabs()}

            <Tab registerDataHandler={this.registerDataHandler} registerValidations={this.registerValidations} />
          </div>


          <button type="submit" className="big shadowed">Save Changes</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Email/index.js